import { StatusList } from "../../../type/apiType/IAPI_CON024";

function funInfoBodyList(list?: StatusList[]) {
  const bodyList = list?.map((item) => [
    {
      children: item.managerName,
    },
    {
      children: item.process,
    },
    {
      children: item.createDate,
      align: "center",
    },
    {
      children: item.processComment,
    },
  ]);

  return bodyList;
}

export { funInfoBodyList };
